import React from "react";
import { useField, useFormikContext } from "formik";
import FileUploadBase from "../Forms/FileUpload";

const FormFileUpload = ({
  name,
  label,
  required = false,
  onFileSelect = null,
}) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  const handleChange = (file) => {
    setFieldValue("remove_" + name, false);
    helpers.setValue(file);
    onFileSelect?.(file);
  };

  const handleRemove = () => {
    setFieldValue("remove_" + name, true);
    helpers.setValue(null);
    onFileSelect?.(null);
  };

  return (
    <FileUploadBase
      name={name}
      value={field.value}
      onChange={handleChange}
      onRemove={handleRemove}
      label={label}
      required={required}
      error={meta.error}
    />
  );
};

export default FormFileUpload;
